import React from "react";
import style from "./ReviewsCard.module.css";

export const ReviewsCard = ({ review: { name, date, text } }) => {
  return (
    <article className={style.reviewCard}>
      <p className={style.reviewCardName}>{name}</p>
      <time className={style.reviewCardData}>{date}</time>
      <div className={style.reviewCardLine} />
      <p className={style.reviewCardText}>{text}</p>
    </article>
  );
};
